import { zodResolver as hookFormZodResolver } from '@hookform/resolvers/zod'
import type { FieldValues, Resolver } from 'react-hook-form'
import type { z } from 'zod'

type HookFormZodResolver = typeof hookFormZodResolver
type ZodResolverSchema = Parameters<HookFormZodResolver>[0]
type ZodResolverOptions = Parameters<HookFormZodResolver>[1]
type ZodResolverFactoryOptions = Parameters<HookFormZodResolver>[2]

/**
 * Bridges Zod 3 schemas to @hookform/resolvers, which types its input against Zod 4.
 */
export function zodResolver<
  TSchema extends z.ZodTypeAny,
  TFieldValues extends FieldValues = z.infer<TSchema> & FieldValues,
>(
  schema: TSchema,
  schemaOptions?: ZodResolverOptions,
  factoryOptions?: ZodResolverFactoryOptions,
): Resolver<TFieldValues> {
  return hookFormZodResolver(
    schema as unknown as ZodResolverSchema,
    schemaOptions,
    factoryOptions,
  ) as Resolver<TFieldValues>
}
